import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Skeleton as AbyssSkeleton } from '@uhg-abyss/web/ui/Skeleton';
import { motion } from 'framer-motion';
import React from 'react';

/**
 * Skeleton
 *
 * This is displayed to resemble an idea of what the final rendered output will look like while the data is loading.
 *
 * @returns {Element}
 * @constructor
 */
export function Skeleton() {
  return (
    <ErrorHandler location="src/features/Risk/components/tables/RiskRecords/components/ExpansionRow/components/Skeleton.jsx">
      <motion.div
        animate="open"
        initial={{ opacity: 0 }}
        variants={{
          closed: { opacity: 0 },
          open: { opacity: 1 },
        }}
      >
        <Grid css={{ margin: 0 }}>
          <Grid.Col
            span={{
              xs: '100%',
            }}
          >
            <Layout.Stack alignItems="left">
              <AbyssSkeleton height={themeConfiguration?.theme?.space?.lg} width={300} />
              <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width={200} />
            </Layout.Stack>
          </Grid.Col>
          <Grid.Col
            span={{
              xs: '50%',
            }}
          >
            <Layout.Stack alignItems="left" grow>
              <Layout.Group grow>
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.lg} width="100%" />
              </Layout.Group>
              <Layout.Group grow>
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width="100%" />
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width="100%" />
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width="100%" />
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width="100%" />
              </Layout.Group>
              <Layout.Group grow>
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width="100%" />
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width="100%" />
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width="100%" />
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width="100%" />
              </Layout.Group>
            </Layout.Stack>
          </Grid.Col>
          <Grid.Col
            span={{
              xs: '25%',
            }}
          >
            <Layout.Stack alignItems="left" grow>
              <Layout.Group grow>
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.lg} width="100%" />
              </Layout.Group>
              <Layout.Group grow>
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width="100%" />
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width="100%" />
              </Layout.Group>
              <Layout.Group grow>
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width="100%" />
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width="100%" />
              </Layout.Group>
            </Layout.Stack>
          </Grid.Col>
          <Grid.Col
            span={{
              xs: '25%',
            }}
          >
            <Layout.Stack alignItems="left" grow>
              <Layout.Group grow>
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.lg} width="100%" />
              </Layout.Group>
              <Layout.Group grow>
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width="100%" />
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width="100%" />
              </Layout.Group>
              <Layout.Group grow>
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width="100%" />
                <AbyssSkeleton height={themeConfiguration?.theme?.space?.md} width="100%" />
              </Layout.Group>
            </Layout.Stack>
          </Grid.Col>
        </Grid>
      </motion.div>
    </ErrorHandler>
  );
}
